import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import type { SiteHeaderView } from "@/api/types";

export function SiteInfoCards({ site }: { site: SiteHeaderView }) {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 2, mb: 3 }}>
      <Card variant="outlined"><CardContent>
        <Typography variant="overline" color="text.secondary">Corporate Address</Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {site.street ?? "—"}
          {site.city && (<><br />{site.city}{site.state ? `, ${site.state}` : ""} {site.postal_code ?? ""}</>)}
        </Typography>
      </CardContent></Card>
      <Card variant="outlined"><CardContent>
        <Typography variant="overline" color="text.secondary">Primary Site Contact</Typography>
        {site.primary_contact ? (
          <Box sx={{ mt: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {site.primary_contact.name}
              {site.primary_contact.title && (
                <Typography component="span" variant="body2" color="text.secondary">
                  {` · ${site.primary_contact.title}`}
                </Typography>
              )}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {site.primary_contact.email ?? "—"} · {site.primary_contact.phone ?? "—"}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Choose primary contact
          </Typography>
        )}
      </CardContent></Card>
      <Card variant="outlined"><CardContent>
        <Typography variant="overline" color="text.secondary">Allowed Email Domains</Typography>
        <Box sx={{ mt: 0.5 }}>
          {site.allowed_email_domains.length === 0 ? (
            <Typography variant="body2" color="text.secondary">—</Typography>
          ) : (
            site.allowed_email_domains.map((d) => (
              <Chip key={d} size="small" label={d}
                    sx={{ mr: 0.5, mb: 0.5, fontFamily: "ui-monospace, Menlo, monospace", fontSize: 11 }} />
            ))
          )}
        </Box>
      </CardContent></Card>
    </Box>
  );
}
